<template>
  <div class="text-12px">
    <WcDialog :close-sync="data.isVisible" :title="data.title" @close-jdialog="closeDialog">
      <template v-if="data.description" #content>
        <div class="flex flex-wrap" style="max-width: 40rem">
          <div v-html="data.description" class="text-12px" />
        </div>
      </template>
      <template #footer>
        <div class="flex items-center justify-end gap-1">
          <Button @click="closeDialog" type="info" plain >{{ $t('general.cancel') }}</Button>
          <Button data-testid="btn-confirm" :loading="data.loading" @click="confirmAction" :type="data.buttonType">
            <b>{{ data.confirmationText }}</b>
          </Button>
        </div>
      </template>
    </WcDialog>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import WcDialog from '@/components/UILibrary/WcDialog.vue'
import Button from '@/components/UILibrary/Buttons/Button.vue'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import { ConfirmationDialogData } from '@/views/recruiter/hiring-plan/models/requisition-payload.dto'

@Component({
  components: {
    WcDialog,
    Button,
    WcTypography
  }
})
export default class ActionConfirmationDialog extends Vue {
  @Prop({ required: true, default: false }) data!: ConfirmationDialogData
  async confirmAction(): Promise<void> {
    this.$emit('confirm')
  }

  closeDialog(): void {
    this.$emit('close-dialog')
  }
}
</script>

<style scoped>
</style>
